import './GuidesSlider.scss';
import template from './GuidesSlider.vhtml';
import CenterSlider from '../CenterSlider';
import SliderNavigation from '../SliderNavigation';

const slickOptions = {
	arrows: false,
	slidesToShow: 3,
	slidesToScroll: 3,
	swipeToSlide: true,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				centerMode: false,
			},
		},
		{
			breakpoint: 500,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
};

export default {
	name: 'GuidesSlider',
	template,
	components: { CenterSlider, SliderNavigation },
	methods: {
		next() {
			this.$refs.slider.next();
		},
		prev() {
			this.$refs.slider.prev();
		},
	},
	created() {
		this.$options.slickOptions = slickOptions;
	},
};
